export enum sentiments {
  title = 'sentiments.title',
  description = 'sentiments.description',
}